import GetPage from './classes/GetPage';
import PageUpdater from './classes/PageUpdater';
import PaginationParser from './classes/PaginationParser';
import ParsedPage from './classes/ParsedPage';
import PostsParser from './classes/PostsParser';
import Settings, { ISettingsType } from './Settings';

export default abstract class ALazyMonkeyPagination {
  protected settings: ISettingsType;
  protected pageUpdater: PageUpdater;
  private paginationParser: PaginationParser;
  private postsParser: PostsParser;

  public constructor(settings: Settings) {
    this.settings = settings.getSettings();
    this.paginationParser = new PaginationParser(
      document,
      this.settings.paginationWrapper,
      this.settings.nextPageSelector
    );
    this.postsParser = new PostsParser(
      document,
      this.settings.postsWrapper,
      this.settings.postWrapper
    );
    this.pageUpdater = new PageUpdater(this.paginationParser, this.postsParser);
  }

  public initialize(): void {
    if (this.paginationParser.hasNextPage()) {
      this.initializeLoader(this.paginationParser.getNextPageUrl());
    }
  }

  protected abstract initializeLoader(nextPageLink: string): void;
  protected abstract removeLoader(): void;

  protected async addNextPagePosts(nextPageLink: string): Promise<void> {
    const response = await new GetPage().get(nextPageLink);
    const responseDocument = new ParsedPage().parse(response);
    const postsPart = new PostsParser(
      responseDocument,
      this.settings.postsWrapper,
      this.settings.postWrapper
    ).getAllPosts();
    this.pageUpdater.addToPosts(postsPart);
    const paginationParser = new PaginationParser(
      responseDocument,
      this.settings.paginationWrapper,
      this.settings.nextPageSelector
    );
    if (paginationParser.hasNextPage()) {
      this.initializeLoader(paginationParser.getNextPageUrl());
    } else {
      this.removeLoader();
    }
  }
}
